<script module>
  import Content from "./Content.svelte";
  import UpgradeModal from "../../../modals/UpgradeModal/UpgradeModal.svelte";
  import * as systemBanner from "@sourcewhale/shared/svelte-design-system/components/atoms/SystemBanner/utils.svelte";

  let alert = $state({});
  let showUpgradeModal = $state(false);

  const onUpgrade = () => {
    showUpgradeModal = true;
  };

  const closeModal = () => {
    showUpgradeModal = false;
  };

  const showTrialEndingBanner = () => {
    systemBanner.addNotification({
      props: {
        style:
          "background-color: #fff2fa; border: 1px solid #fff2fa; border-bottom: 1px solid #ffbae5;",
      },
      content,
    });
  };

  export { showTrialEndingBanner };
</script>

{#snippet content()}
  <Content {alert} {onUpgrade} />
  {#if showUpgradeModal}
    <UpgradeModal onClose={closeModal} />
  {/if}
{/snippet}
